import { CALL_API } from 'redux-api-middleware'
import {
  CREATE_CONTACTSTAFF_REQUEST,
  CREATE_CONTACTSTAFF_SUCCESS,
  CREATE_CONTACTSTAFF_FAILURE,
} from './types'

import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const handleCreateContactStaff = (endpoint, dataForm) => {
  const formData = new FormData()
  Object.keys(dataForm).forEach((key) => {
    formData.append(key, dataForm[key])
  })
  return {
    [CALL_API]: {
      endpoint,
      method: 'POST',
      body: formData,
      headers,
      types: [CREATE_CONTACTSTAFF_REQUEST, CREATE_CONTACTSTAFF_SUCCESS, CREATE_CONTACTSTAFF_FAILURE],
    },
  }
}




// WEBPACK FOOTER //
// ./src/actions/contactstaff.js